import {Location} from '@reach/router'
import compact from 'lodash/compact'
import {graphql} from 'gatsby'
import {StaticResourcePageFragment} from 'gatsby-graphql-types-generated'
import React, {useEffect} from 'react'
import {toast} from 'react-toastify'


import Breadcrumbs from 'src/components/Breadcrumbs'
import {Box, PositionContainer, Grid} from 'src/components/Box'
import {HeaderXl, Header3, Lede} from 'src/components/text'
import WysiwygContent from 'src/components/WysiwygContent'
import Layout from 'src/components/Layout'
import SEO from 'src/components/SEO'
import FlairBox from 'src/components/FlairBox'
import {FlairProvider} from 'src/context/FlairContext'
import {Maybe} from 'src/graphql-generated'
import useViewer from 'src/hooks/useViewer'
import ButtonLink from 'src/components/ButtonLink'
import {localPaths} from 'src/urls'
import {Link} from 'src/components/Link'
import HeroImage from 'src/components/HeroImage'
import useCourseCompletedInteraction from 'src/hooks/useCourseCompletedInteraction'
import 'react-toastify/dist/ReactToastify.css'
import {parseErrorString} from 'src/lib/util'

interface Props {
  resourcePage: StaticResourcePageFragment
}

const GatedContent: React.FunctionComponent<{
  ctaLabel?: Maybe<string>
  children?: React.ReactNode | React.ReactNode[]
}> = ({ctaLabel = 'Must be logged in to view content', children}) => {
  const {viewer} = useViewer()
  const createInteraction = useCourseCompletedInteraction()

  const completeAsaStep = async ({
    stepNumber,
    userId,
    uniqueTaskKey,
  }: {
    stepNumber: number
    userId: number
    uniqueTaskKey: string
  }): Promise<boolean> => {
    try {
      const evolveMeUrl = process.env.GATSBY_EVOLVE_ME_URL
      const payload = {
        stepNumber,
        userId,
        uniqueTaskKey,
        evolveMeUrl,
      }
      console.log('Sending payload:', payload)
      const response = await fetch(
        'https://getschooled.com/.netlify/functions/completeAsaStep',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        }
      )
      console.log(response)
      if (!response.ok) {
        const text = await response.text()
        throw new Error(text)
      }

      return true
    } catch (error: any) {
      console.error('completeAsaStep error:', error)
      const parsed = parseErrorString(error?.message || '')
      if (parsed?.errorCode?.includes('EM2')) {
        toast.error(parsed.errorMessage, {
          position: 'top-center',
          autoClose: 3000,
          theme: 'light',
        })
      } else {
        toast.error(
          'Something went wrong completing the task step to evolve me.',
          {
            position: 'top-center',
            autoClose: 3000,
            theme: 'light',
          }
        )
      }
      return false
    }
  }

  useEffect(() => {
    const run = async () => {
      createInteraction({
        variables: {
          taskId: process.env.GATSBY_CONTENTFUL_Resume_Builder_Task_ID,
          stepId: process.env.GATSBY_CONTENTFUL_Resume_Builder_Step_ID,
        },
      })

      const EVOLVE_ME_FRONTEND_URL =
        localStorage.getItem('EVOLVE_ME_FRONTEND_URL') ||
        process.env.GATSBY_EVOLVE_ME_FRONTEND_URL
      const searchParams = new URLSearchParams(window.location.search)
      const querySource = searchParams.get('student_source')
      const localSource = localStorage.getItem('student_source')
      localStorage.removeItem('EVOLVE_ME_FRONTEND_URL')
      // localStorage.removeItem('student_source')
      console.log('sources at this point:', 'query', querySource, 'local', localSource)

      const userId = parseInt(localStorage.getItem('user_id') || '')
      const uniqueTaskKey = localStorage.getItem('unique_task_key') || ''
      const stepNumber = parseInt(localStorage.getItem('step_number') || '')

      console.log(querySource)
      console.log('userId:', userId)
      console.log('uniqueTaskKey:', uniqueTaskKey)
      console.log('stepNumber:', stepNumber)

      if (
        (querySource === 'evolveme' || localSource === 'evolveme') &&
        !isNaN(userId) &&
        !isNaN(stepNumber) &&
        uniqueTaskKey
      ) {
        const success = await completeAsaStep({
          stepNumber,
          userId,
          uniqueTaskKey,
        })
        if (success) {
          window.location.href = `${EVOLVE_ME_FRONTEND_URL}/dashboard`
        }
      }
    }

    run()
  }, [])


  if (viewer === 'not-logged-in') {
    return (
      <Location>
        {({location}) => (
          <Grid css={{textAlign: 'center'}} justifyContent="center" gridGap="3">
            <Header3>{ctaLabel}</Header3>
            <ButtonLink
              to={localPaths.signUp}
              state={{returnTo: location.pathname}}
            >
              Sign Up
            </ButtonLink>
            <Link to={localPaths.login} state={{returnTo: location.pathname}}>
              Log in
            </Link>
          </Grid>
        )}
      </Location>
    )
  }

  if (viewer) {
    return <>{children}</>
  }

  return null
}

export const ResourcePageTemplate = ({resourcePage}: Props) => {
  const includeFlair = !resourcePage.isLegal
  // const isLms = isLmsImplementation()

  // if (isLms) {
  //   return (
  //     <>
  //       <SEO title={resourcePage.title} permalink={resourcePage.permalink} />
  //       <FlairProvider seed={parseInt(resourcePage.id, 16)}>
  //         {resourcePage.heroUrl && (
  //           <Box mx={{_: -3, lg: 0}}>
  //             <HeroImage
  //               alt={resourcePage.title}
  //               file={resourcePage.heroFile}
  //               url={resourcePage.heroUrl}
  //             />
  //           </Box>
  //         )}
  //         <Box my="2">
  //           <Breadcrumbs
  //             ancestors={resourcePage.ancestorPages.map((a) => ({
  //               name: a.title,
  //               permalink: a.permalink,
  //             }))}
  //           />
  //         </Box>
  //         <Grid
  //           as="article"
  //           mx={{default: -3, lg: 0}}
  //           px={{default: 3, lg: 0}}
  //           overflowX={{default: 'hidden', lg: 'visible'}}
  //           gridGap="4"
  //         >
  //           <PositionContainer position="relative">
  //             {includeFlair ? (
  //               <FlairBox
  //                 right={-100}
  //                 verticalCenter
  //                 width={200}
  //                 height={200}
  //               />
  //             ) : null}
  //             <HeaderXl breakWord>{resourcePage.title}</HeaderXl>
  //           </PositionContainer>

  //           {resourcePage.lede &&
  //             compact(resourcePage.lede.split(/\r?\n/)).map(
  //               (subLede, index) => <Lede key={index}>{subLede}</Lede>
  //             )}

  //           {resourcePage.body && (
  //             <WysiwygContent
  //               content={resourcePage.body}
  //               withFlair={includeFlair}
  //             />
  //           )}

  //           {resourcePage.gatedBody && (
  //             <GatedContent ctaLabel={resourcePage.ctaLabel}>
  //               <WysiwygContent
  //                 content={resourcePage.gatedBody}
  //                 withFlair={includeFlair}
  //               />
  //             </GatedContent>
  //           )}
  //         </Grid>
  //       </FlairProvider>
  //     </>
  //   )
  // }

  return (
    <Layout narrow>
      <SEO title={resourcePage.title} permalink={resourcePage.permalink} />
      <FlairProvider seed={parseInt(resourcePage.id, 16)}>
        {resourcePage.heroUrl && (
          <Box mx={{_: -3, lg: 0}}>
            <HeroImage
              alt={resourcePage.title}
              file={resourcePage.heroFile}
              url={resourcePage.heroUrl}
            />
          </Box>
        )}
        <Box my="2">
          <Breadcrumbs
            ancestors={
              resourcePage.ancestorPages !== null
                ? resourcePage.ancestorPages.map((a) => ({
                    name: a.title,
                    permalink: a.permalink,
                  }))
                : []
            }
          />
        </Box>
        <Grid
          as="article"
          mx={{default: -3, lg: 0}}
          px={{default: 3, lg: 0}}
          overflowX={{default: 'hidden', lg: 'visible'}}
          gridGap="4"
        >
          <PositionContainer position="relative">
            {includeFlair ? (
              <FlairBox right={-100} verticalCenter width={200} height={200} />
            ) : null}
            <HeaderXl breakWord>{resourcePage.title}</HeaderXl>
          </PositionContainer>

          {resourcePage.lede?.lede &&
            compact(resourcePage.lede.lede?.split(/\r?\n/)).map(
              (subLede, index) => <Lede key={index}>{subLede}</Lede>
            )}

          {resourcePage.body?.body && (
            <WysiwygContent
              content={resourcePage.body.body}
              withFlair={includeFlair}
            />
          )}

          {resourcePage.gatedBody?.gatedBody && (
            <GatedContent ctaLabel={resourcePage.ctaLabel}>
              <WysiwygContent
                content={resourcePage.gatedBody.gatedBody}
                withFlair={includeFlair}
              />
            </GatedContent>
          )}
        </Grid>
      </FlairProvider>
    </Layout>
  )
}

export const query = graphql`
  fragment StaticResourcePage on ContentfulResourcePage {
    id
    title
    permalink
    body {
      body
    }
    updatedAt
    isLegal
    gatedBody {
      gatedBody
    }
    ctaLabel
    heroUrl
    heroFile {
      ...HeroImage
    }
    lede {
      lede
    }
    ancestorPages: resource_page {
      id
      title
      permalink
    }
  }
`

export default ResourcePageTemplate
